import { colors } from 'component-library';
import { useNavigate } from 'react-router';
import { useState } from 'react';
import { type TextType } from '#lib/HeaderMenu/types';
import { getStartUrl } from '#lib/utils/environment';
import { Link, LinkWrapper } from '../styles';
import { SupportIcon } from '../UserMenuIcons';

const ContactSupportLink = ({ text, closeMenu }: { text: TextType; closeMenu: () => void }) => {
  const url = `${getStartUrl()}support`;

  const navigate = useNavigate();

  const [hover, setHover] = useState(false);

  const handleOnClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    void navigate('/support');
    closeMenu();
  };

  return (
    <LinkWrapper
      onMouseEnter={() => {
        setHover(true);
      }}
      onMouseLeave={() => {
        setHover(false);
      }}
    >
      <Link
        onClick={(e) => {
          handleOnClick(e);
        }}
        href={url}
      >
        <SupportIcon color={hover ? colors.primary.blue : colors.base.black} />
        <span>{text.contactSupport}</span>
      </Link>
    </LinkWrapper>
  );
};

export default ContactSupportLink;
